<template>
<div class='metro-station'>
    <h4>
        <b-icon v-if="station.status == 'error' || station.status == 'warning'" icon="exclamation-triangle"></b-icon>
        <b-icon v-else icon="check-square"></b-icon>
        <span >{{ station.name }}</span>
        <b-icon icon="x-lg" class='close-btn' @click="close"></b-icon>
    </h4>


    <div class='platform-displays'>
        <fieldset>
            <legend>Laituri 1</legend>
            <PlatformInfo v-if="station.info"></PlatformInfo>
            <PlatformDisplay :id="getId(1)" :state="station.state"></PlatformDisplay>
            <PlatformDisplay :id="getId(2)" :state="station.state"></PlatformDisplay>
        </fieldset>

        <fieldset>
            <legend>Laituri 2</legend>
            <PlatformInfo v-if="station.info"></PlatformInfo>         
            <PlatformDisplay :id="getId(3)" :status="station.status" :state="station.state"></PlatformDisplay>
            <PlatformDisplay :id="getId(4)" :state="station.state"></PlatformDisplay>            
        </fieldset>

        <fieldset v-if="station.platforms == 3">
            <legend v-if="station.info">Laituri 3</legend>
            <PlatformInfo></PlatformInfo>         
            <PlatformDisplay :id="getId(5)"></PlatformDisplay>
            <PlatformDisplay :id="getId(6)"></PlatformDisplay>
        </fieldset>
        
      </div>
<!--
        <div class='platform-displays'>
        <fieldset>
            <legend>Laituri 1</legend>
            <NextDepartures v-if="noSelection(1)" :departures="L1_departures"></NextDepartures>
             <div class='displays'>
                <PlatformDisplay v-if="selected(1,1) || noSelection(1)" :selected="selected(1,1)" :id="getId(1)" @click.native="select(1,1)" state="off"></PlatformDisplay>
                <PlatformDisplay v-if="selected(1,2) || noSelection(1)" :selected="selected(1,2)" :id="getId(2)" @click.native="select(1,2)"></PlatformDisplay>
            </div>
        </fieldset>

        <fieldset>
            <legend>Laituri 2</legend>
             <NextDepartures v-if="noSelection(2)" :departures="L2_departures"></NextDepartures>
            <div class='displays'>
                <PlatformDisplay v-if="selected(2,1) || noSelection(2)" :selected="selected(2,1)" :id="getId(3)" @click.native="select(2,1)" :status="station.status"></PlatformDisplay>
                <PlatformDisplay v-if="selected(2,2) || noSelection(2)" :selected="selected(2,2)" :id="getId(4)" @click.native="select(2,2)"></PlatformDisplay>
            </div>
            
        </fieldset>

        <fieldset v-if="station.platforms == 3">
            <legend>Laituri 3</legend>
            <NextDepartures v-if="noSelection(3)" :departures="L1_departures"></NextDepartures>
            <div class='displays'>
                <PlatformDisplay v-if="selected(3,1) || noSelection(3)" :selected="selected(3,1)" :id="getId(5)" @click.native="select(3,1)"></PlatformDisplay>
                <PlatformDisplay v-if="selected(3,2) || noSelection(3)" :selected="selected(3,2)" :id="getId(6)" @click.native="select(3,2)"></PlatformDisplay>
            </div>
        </fieldset>
        
      </div>
    -->
</div>
</template>

<script>

import PlatformDisplay from '@/components/Metro/PlatformDisplay.vue'
import PlatformInfo from '@/components/Metro/PlatformInfo.vue'

/*import NextDepartures from '@/components/Metro/NextDepartures.vue'*/

export default {
    components: { PlatformDisplay, PlatformInfo /*NextDepartures*/ },
    props: ['station'],
    data: function() {
        return  {
            L1_departures: [
                { line: "M2", destination: "Mellunmäki", arr_time: "10:00:00", rt_arr_time: "10:00:30", dep_time: "10:01:00", rt_dep_time: "10:01:30" },
                { line: "M1", destination: "Vuosaari", arr_time: "10:03:00", rt_arr_time: "10:03:30", dep_time: "10:04:00", rt_dep_time: "10:04:30" },
                { line: "M2", destination: "Mellunmäki", arr_time: "10:06:00", rt_arr_time: "10:06:30", dep_time: "10:07:00", rt_dep_time: "10:07:30" },
                { line: "M1", destination: "Vuosaari", arr_time: "10:09:00", rt_arr_time: "10:09:30", dep_time: "10:10:00", rt_dep_time: "10:10:30" },
                { line: "M2", destination: "Mellunmäki", arr_time: "10:12:00", rt_arr_time: "10:12:30", dep_time: "10:13:00", rt_dep_time: "10:13:30" },
               /* { line: "M1", destination: "Vuosaari", arr_time: "10:15:00", rt_arr_time: "10:15:30", dep_time: "10:16:00", rt_dep_time: "10:16:30" },*/
            ],
            L2_departures: [
                { line: "M2", destination: "Tapiola", arr_time: "10:00:00", rt_arr_time: "10:00:30", dep_time: "10:01:00", rt_dep_time: "10:01:30" },
                { line: "M1", destination: "Kivenlahti", arr_time: "10:03:00", rt_arr_time: "10:03:30", dep_time: "10:04:00", rt_dep_time: "10:04:30" },
                { line: "M2", destination: "Tapiola", arr_time: "10:06:00", rt_arr_time: "10:06:30", dep_time: "10:07:00", rt_dep_time: "10:07:30" },
                { line: "M1", destination: "Kivenlahti", arr_time: "10:09:00", rt_arr_time: "10:09:30", dep_time: "10:10:00", rt_dep_time: "10:10:30" },
                { line: "M2", destination: "Tapiola", arr_time: "10:12:00", rt_arr_time: "10:12:30", dep_time: "10:13:00", rt_dep_time: "10:13:30" },
               /*  { line: "M1", destination: "Kivenlahti", arr_time: "10:15:00", rt_arr_time: "10:15:30", dep_time: "10:16:00", rt_dep_time: "10:16:30" }, */
            ],
            p1_selection: 0,
            p2_selection: 0,
            p3_selection: 0
        }
    },
   
    methods : {
        getId(platform){
            //return (this.station.name.substring(0, 3) + "-INFO-" + platform).toUpperCase();
            return (this.station.code + "-INFO-" + platform).toUpperCase();
        },
        close(){
            this.$emit('close', this.station.id);
        },
        noSelection(platform){
            let selection = 0;
            if(platform == 1) selection = this.p1_selection;
            if(platform == 2) selection = this.p2_selection;
            if(platform == 3) selection = this.p3_selection;
            return !selection;
        },
        selected(platform, id){
            let selection = -1;
            if(platform == 1) selection = this.p1_selection;
            if(platform == 2) selection = this.p2_selection;
            if(platform == 3) selection = this.p3_selection;
            return selection == id;
        },
        select(platform, id){
            if(platform == 1)
                this.p1_selection =  this.p1_selection == id ? 0 : id;

             if(platform == 2)
                this.p2_selection =  this.p2_selection == id ? 0 : id;

            if(platform == 3)
                this.p3_selection =  this.p3_selection == id ? 0 : id;
        },
        selectP1(id){
            this.p1_selection =  this.p1_selection == id ? 0 : id;
        }
        
    }
}
</script>

